import { KeyDrop, Keys, Values } from "@pdfking/tfunc"

const RESERVED: string[] = ["enum"]

// Evaluates the template as a JS template literal so expressions like
// ${parseInt(done / 1000)} work, matching the existing render_string behaviour.
export const FormatTemplate = (template: string, context: Record<string, unknown>): string => {
  const safe = KeyDrop(context, RESERVED)
  // eslint-disable-next-line no-implied-eval -- intentional: evaluates the string as a JS template literal
  const fn = new Function(...Keys(safe), `return \`${template}\``)
  return fn(...Values(safe))
}
